<input
    type="button"
    #openModal
    data-bs-toggle="modal"
    data-bs-target="#client-modal"
    [attr.data-bs-backdrop]="backdrop"
    data-bs-keyboard="false"
    class="hidden"
/>

<div class="modal fade" id="client-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <button
                #closeModal
                type="button"
                class="close hidden"
                data-bs-dismiss="modal"
                aria-label="Close"
            >
            </button>
            <div class="modal-body">
                <data-table [dataset]="clients" *ngIf="clients.length > 0">
                    <column
                        value="logoUrl"
                        header=" "
                        type="Image"
                        width="150px"
                        [filterable]="false"
                        [sortable]="false"
                    ></column>
                    <column
                        value="name"
                        type="Button"
                        header="Name"
                        [options]="options"
                        styleClass="text-start"
                    ></column>
                </data-table>
            </div>
        </div>
    </div>
</div>
